'use client'
import { TToastProps, Toast } from '@populix/pop-ui'
import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useCallback,
  useMemo,
  useState,
} from 'react'
import { createPortal } from 'react-dom'

export interface TToastContext extends TToastProps {
  setState?: Dispatch<SetStateAction<TToastContext>>
}

export const ToastContext = createContext<TToastContext | null>(null)

export const defaultToastState: TToastContext = {
  show: false,
  positionBottom: false,
  type: 'success',
  title: '',
  description: '',
  traceId: '',
  disableClose: false,
  onClose: undefined,
  transformTitle: true,
}

const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<TToastContext>(defaultToastState)

  const onClose = useCallback(() => setState({ ...defaultToastState }), [])

  const value: TToastContext = useMemo(
    () => ({
      ...state,
      setState,
      onClose,
    }),
    [state, setState, onClose],
  )

  return (
    <ToastContext.Provider value={value}>
      {children}
      {state.show && createPortal(<Toast {...state} onClose={onClose} />, document.body)}
    </ToastContext.Provider>
  )
}

export default ToastProvider
